import type { ReactNode } from "react";
import { RotaHostContext, type RotaHost } from "./host";

/** Liga a Venda na Rota à sessão e às telas do app que a hospeda. */
export function RotaHostProvider({ value, children }: { value: RotaHost; children: ReactNode }) {
  return <RotaHostContext.Provider value={value}>{children}</RotaHostContext.Provider>;
}
